export enum FieldOptionsStringFormatType {
    mask = 'mask',
    regex = 'regex',
}
